export default __webpack_public_path__ + "f20e14620d87aa4ea56ee286c48afd03.svg";